<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { faCog } from '@fortawesome/duotone-regular-svg-icons'
import useSettingsStore from '~/stores/settings'
import useAuthStore from '~/stores/auth'
import { PendoFeature } from '~/models/Pendo'
import useSettings from '~/composables/useSettings'
import Tooltip from '~/components/ui/Tooltip.vue'
import Button from '~/components/ui/Button.vue'
import SettingsDrawer from '~/components/settings/SettingsDrawer.vue'

const emit = defineEmits(['close'])

const { t } = useI18n()
const { toggleSettings } = useSettings()
const { drawerOpen } = storeToRefs(useSettingsStore())
const { isAuthenticated } = storeToRefs(useAuthStore())

const close = () => {
  toggleSettings()
  emit('close')
}
</script>

<template>
  <div>
    <Button
      :data-pendo="PendoFeature.Navigation.Settings"
      class="w-full sm:hidden"
      size="xl"
      :disabled="!isAuthenticated"
      @click.prevent="toggleSettings()"
    >
      <font-awesome-icon :icon="faCog" size="lg" />
      {{ t('settings.title') }}
    </Button>
    <Tooltip :content="t('settings.title')">
      <Button
        :data-pendo="PendoFeature.Navigation.Settings"
        class="hidden sm:block"
        shape="square"
        size="xl"
        :disabled="!isAuthenticated"
        v-bind="$attrs"
        @click.prevent="toggleSettings()"
      >
        <font-awesome-icon :icon="faCog" size="lg" />
      </Button>
    </Tooltip>
    <SettingsDrawer
      :open="drawerOpen"
      @close="close"
    />
  </div>
</template>
